import EnemyType from "../enums/EnemyType";
import EnemyData from "./enemys/EnemyDataInterface";
import EASY_ENEMYS from "./enemys/EASY_ENEMYS";
import BOSS_ENEMYS from "./enemys/BOSS_ENEMYS";
import SWARM_ENEMYS from "./enemys/SWARM_ENEMYS";
import MEDIUM_ENEMYS from "./enemys/MEDIUM_ENEMYS";
import DIFFICULT_ENEMYS from "./enemys/DIFFICULT_ENEMYS";
import SPECIAL_ENEMYS from "./enemys/SPECIAL_ENEMYS";
import GREEN_STAGES_SWARMS from "./enemys/GREEN_STAGES_SWARMS";
import GREEN_STAGES_BOSSES from "./enemys/GREEN_STAGES_BOSSES";
import GREEN_STAGES_ENEMIES from "./enemys/GREEN_STAGES_ENEMIES";

const ENEMYS: {
  [key in EnemyType]?: EnemyData[];
} = {
  ...EASY_ENEMYS,
  ...MEDIUM_ENEMYS,
  ...DIFFICULT_ENEMYS,
  ...SWARM_ENEMYS,
  ...BOSS_ENEMYS,
  ...SPECIAL_ENEMYS,
  ...GREEN_STAGES_ENEMIES,
  ...GREEN_STAGES_SWARMS,
  ...GREEN_STAGES_BOSSES,
};

export default ENEMYS;
